import MyTextField from "../TextField";
import { FormControl, Select, MenuItem } from "@mui/material";
import MyMenuList from "../MenuList";
import MyTextLabel from "../InputLabel";

const FormScreenFour = ({ formData, formErrors, handleChange }) => {
  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.sameSexRoomieError}
      >
        <MyTextLabel shrink htmlFor={"sameSexRoomie"}>
          Do You Mind Staying With An Opposite Gender?
        </MyTextLabel>
        <Select
          id={"sameSexRoomie"}
          value={formData.sameSexRoomie}
          onChange={handleChange}
          input={<MyTextField />}
          name="sameSexRoomie"
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return "Yes";
            }
            return selected;
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
        >
          <MyMenuList value={""} disabled>
            Yes
          </MyMenuList>
          <MyMenuList value={"Yes"} name={"yes"}>
            Yes
          </MyMenuList>
          <MyMenuList value={"no"} name={"no"}>
            No
          </MyMenuList>
        </Select>
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.emergencyPhoneError}
      >
        <MyTextLabel shrink htmlFor={"emergencyPhone"}>
          Drop An Emergency Contact
        </MyTextLabel>
        <MyTextField
          id={"emergencyPhone"}
          placeholder="09138308323"
          value={formData.emergencyPhone}
          name="emergencyPhone"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.emergencyRelationError}
      >
        <MyTextLabel shrink htmlFor={"emergencyRelation"}>
          What Is Your Relationship With Your Emergency Contact?
        </MyTextLabel>
        <MyTextField
          id={"emergencyRelation"}
          value={formData.emergencyRelation}
          name="emergencyRelation"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        error={!!formErrors.suggestionsError}
      >
        <MyTextLabel shrink htmlFor={"suggestions"}>
          Suggestions /Comments To The Game Makers?
        </MyTextLabel>
        <MyTextField
          id={"suggestions"}
          value={formData.suggestions}
          name="suggestions"
          onChange={handleChange}
        />
      </FormControl>
    </>
  );
};

export default FormScreenFour;
